import logo from '../images/logo.svg'
import { experimentalStyled } from '@mui/material/styles'

const ImgLogo = experimentalStyled('img')({
  width: '52px',
  height: 'auto',
})

const Logo = ({ classes, ...props }) => <ImgLogo src={logo} alt="TorqAgent" {...props} />

export default Logo
